<template>
    <nav>
        <div class = "logo">
            <img src="../assets/misa.png"
                contain
                height="30vw"
                width="180vw">
        </div>
        <router-link to="/" class="nav-link">Home</router-link>
        <router-link to="/primer" class="nav-link">Primer</router-link>
        <!-- <button @click="$router.push('/apply')" class="secondary-btn">Apply</button> -->
        <router-link to="/apply" class="secondary-btn">Apply</router-link>
    </nav>
    
</template>

<script>
export default {
    name: 'Navbar'
}
</script>

<style scoped>
    
nav {
    display: flex;
    flex-direction: row;
    font-size: 20px;
    justify-content: space-between;
    text-emphasis: none;
    text-decoration: none;
    align-items: baseline;
    /* height: 8px; */
    /* margin-top: 31px; */
    margin: 24px 1.5vw  0px 1.5vw;
    background-color: white;
    text-align: center;


    /* position: fixed;
    top: 0px;
    width: 100%;
    overflow-x: hidden;
    padding: 32px 1.5vw  0px 1.5vw; */
}

div {
    height: 52px;
}

button {
    height: 52px;
    width: 20vw;
    /* font-size: 20px; */
}

.logo img{
    width: 16vw;
    min-width: 120px;
    height: auto;
}

a {
    text-decoration: none;
    line-height: 52px;
}

.nav-link {
    width: 20vw;
    height: 52px;
    text-align: center;
    border: none;
    background: none;
    border-bottom: 2px solid #242424; 
    
    color: #242424;
    opacity: 0.5;
}

.router-link-exact-active {
    opacity: 1;
    border-width: 2.5px;
}

.secondary-btn{
    width: 20vw;
    /* height: 52px; */
}

.secondary-btn.router-link-exact-active{
    background: #31A5AF;
    color: white;
    
}

button:hover {
  cursor: pointer;
}


</style>

